// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../Assets/Images/certificate.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../Assets/Images/certificates1.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Partners_partners__hA7g- p {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  text-align: center;
  color: rgba(255, 255, 255, 0.7);
  max-width: 500px;
  margin: 50px auto;
  padding: 10px;
  position: relative;
}
.Partners_partners__hA7g- p:before {
  content: "";
  width: 80%;
  height: 1px;
  position: absolute;
  top: -10px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #ED1C24;
}
.Partners_partners__hA7g- .Partners_partnersList__iJCxE {
  width: 80%;
  margin: auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
@media (max-width: 980px) {
  .Partners_partners__hA7g- .Partners_partnersList__iJCxE {
    justify-content: center;
  }
}
.Partners_partners__hA7g- .Partners_partnersList__iJCxE img {
  margin-bottom: 60px;
}
@media (max-width: 500px) {
  .Partners_partners__hA7g- .Partners_partnersList__iJCxE img {
    width: 250px;
  }
}
.Partners_partners__hA7g- .Partners_partnersList__iJCxE .Partners_item__kAOdS {
  width: 380px;
  height: 220px;
  object-fit: contain;
  border: 0.5px solid rgba(255, 255, 255, 0.63);
}
@media (max-width: 500px) {
  .Partners_partners__hA7g- .Partners_partnersList__iJCxE .Partners_item__kAOdS {
    width: 250px;
    height: 145px;
  }
}

.Partners_partnersHeader__1ffqE {
  background-size: cover;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center;
  min-height: calc(100vh - 100px);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  position: relative;
}
.Partners_partnersHeader__1ffqE .Partners_layer__aOhjN {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
.Partners_partnersHeader__1ffqE h1 {
  text-align: center;
  font-family: "hemi_head";
  font-style: italic;
  font-weight: 400;
  font-size: 64px;
  color: #FFFFFF;
  margin: 0;
  padding-top: 60px;
  z-index: 1;
}
@media (max-width: 780px) {
  .Partners_partnersHeader__1ffqE h1 {
    font-size: 40px;
  }
}
@media (max-width: 400px) {
  .Partners_partnersHeader__1ffqE h1 {
    font-size: 30px;
  }
}
.Partners_partnersHeader__1ffqE p {
  font-size: 20px;
  line-height: 23px;
  text-align: center;
  color: rgba(255, 255, 255, 0.7);
  max-width: 700px;
  padding-bottom: 100px;
  z-index: 1;
}
@media (max-width: 780px) {
  .Partners_partnersHeader__1ffqE p {
    width: 95%;
  }
}

.Partners_title__tipTJ {
  position: absolute;
  top: 10%;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
}
.Partners_title__tipTJ h1 {
  font-family: "hemi_head";
  color: #ffffff;
  font-weight: 400;
  font-size: 64px;
  text-align: center;
}
@media (max-width: 900px) {
  .Partners_title__tipTJ h1 {
    font-size: 42px;
    display: none;
  }
}
@media (max-width: 400px) {
  .Partners_title__tipTJ h1 {
    font-size: 32px;
  }
}

.Partners_videoTag__ZWyQc {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/Pages/Partners/Partners.module.scss"],"names":[],"mappings":"AACE;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,+BAAA;EAEA,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,kBAAA;AADJ;AAEI;EACE,WAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,2BAAA;EACA,yBAAA;AAAN;AAGE;EACE,UAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,8BAAA;AADJ;AAEI;EANF;IAOI,uBAAA;EACJ;AACF;AAAI;EACE,mBAAA;AAEN;AADM;EAFF;IAGI,YAAA;EAIN;AACF;AAFI;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,6CAAA;AAIN;AAHM;EALF;IAME,YAAA;IACE,aAAA;EAMN;AACF;;AADA;EACE,sBAAA;EACA,0DAAA;EACA,+BAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;AAIF;AAHE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,mDAAA;AAKJ;AAFE;EACE,kBAAA;EACA,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,SAAA;EACA,iBAAA;EACA,UAAA;AAIJ;AAHI;EAVF;IAWI,eAAA;EAMJ;AACF;AALI;EAbF;IAcI,eAAA;EAQJ;AACF;AALE;EACE,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,+BAAA;EACA,gBAAA;EACA,qBAAA;EACA,UAAA;AAOJ;AANI;EARF;IASI,UAAA;EASJ;AACF;;AANA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,2BAAA;EACA,WAAA;AASF;AAPE;EACE,wBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;AASJ;AARI;EANF;IAOI,eAAA;IACA,aAAA;EAWJ;AACF;AAVI;EAVF;IAWI,eAAA;EAaJ;AACF;;AAVA;EACE,WAAA;AAaF","sourcesContent":[".partners {\n  p{\n    font-family: 'Roboto';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 16px;\n    text-align: center;\n    color: rgba(255, 255, 255, 0.7);\n    //border-top: 1px solid #ED1C24;\n    max-width: 500px;\n    margin: 50px auto;\n    padding: 10px;\n    position: relative;\n    &:before{\n      content:\"\";\n      width: 80%;\n      height: 1px;\n      position: absolute;\n      top: -10px;\n      left: 50%;\n      transform: translateX(-50%);\n      background-color: #ED1C24;\n    }\n  }\n  .partnersList {\n    width: 80%;\n    margin: auto;\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    @media (max-width: 980px) {\n      justify-content: center;\n    }\n    img {\n      margin-bottom: 60px;\n      @media (max-width: 500px) {\n        width: 250px;\n      }\n    }\n    .item{\n      width:380px;\n      height:220px;\n      object-fit:contain;\n      border:0.5px solid rgba(255,255,255,0.63);\n      @media (max-width: 500px) {\n      width: 250px;\n        height: 145px;\n    }\n\n    }\n  }\n}\n.partnersHeader {\n  background-size: cover;\n  background: url(\"../../Assets/Images/certificate.png\") center;\n  min-height: calc(100vh - 100px);\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: center;\n  position: relative;\n  .layer {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    background: url(\"../../Assets/Images/certificates1.png\");\n  }\n\n  h1 {\n    text-align: center;\n    font-family: 'hemi_head';\n    font-style: italic;\n    font-weight: 400;\n    font-size: 64px;\n    color: #FFFFFF;\n    margin: 0;\n    padding-top: 60px;\n    z-index: 1;\n    @media (max-width: 780px) {\n      font-size: 40px;\n    }\n    @media (max-width: 400px) {\n      font-size: 30px;\n    }\n  }\n\n  p {\n    font-size: 20px;\n    line-height: 23px;\n    text-align: center;\n    color: rgba(255, 255, 255, 0.7);\n    max-width: 700px;\n    padding-bottom: 100px;\n    z-index: 1;\n    @media (max-width: 780px) {\n      width: 95%;\n    }\n  }\n}\n.title {\n  position: absolute;\n  top: 10%;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 10;\n\n  h1 {\n    font-family: \"hemi_head\";\n    color: #ffffff;\n    font-weight: 400;\n    font-size: 64px;\n    text-align: center;\n    @media (max-width: 900px) {\n      font-size: 42px;\n      display: none;\n    }\n    @media (max-width: 400px) {\n      font-size: 32px;\n    }\n  }\n}\n.videoTag {\n  width: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"partners": `Partners_partners__hA7g-`,
	"partnersList": `Partners_partnersList__iJCxE`,
	"item": `Partners_item__kAOdS`,
	"partnersHeader": `Partners_partnersHeader__1ffqE`,
	"layer": `Partners_layer__aOhjN`,
	"title": `Partners_title__tipTJ`,
	"videoTag": `Partners_videoTag__ZWyQc`
};
export default ___CSS_LOADER_EXPORT___;
